import React, {useContext, useEffect} from 'react';
import {authContext} from '../Context/Authentication/authContext';
import {Tabs, Tab, Box} from '@mui/material';

import PredctionDaysOnMarket from './Components/PredctionDaysOnMarket';
import PredictionHomeSales from './Components/PredictionHomeSales';
import PredictionPrice from './Components/PredictionPrice';
import PredictionMsp from './Components/PredictionMsp';

import './Tabs.scss';
import PropertyType from "./Components/PropertyType";
import {a11yProps} from "../Helpers/helpers";
import PredictionRental from './Components/PredictionRental';

const TABS = [
  {name: 'Home sales', title: 'Home sales'},
  {name: 'Days on market', title: 'Days On Market'},
  {name: 'Price', title: 'Price'},
  {name: 'MSP', title: 'Median sales Price'},
  {name: 'Rentals', title: 'Rentals'},
  {name: 'Property Type', title: 'Property Type'},
  
]
const PER_TABS = ['Price', 'MSP', 'Days on market', 'Home sales', 'Property Type']

const PredictionTab = () => {
  const {state, dispatch}: any = useContext(authContext);

  useEffect(() => {
    handleSelectedTab((state.selectedTab && TABS.map((t: any) => t.name).includes(state.selectedTab) ? state.selectedTab : 'Home sales'));
  }, [state?.filters?.city, state?.selectedTab]);


  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    handleSelectedTab(newValue);
  }

  const handleSelectedTab = (val: string) => {
    dispatch({
      type: 'APPLY_FILTER',
      payload: {
        ...state.filters,
        trackEvent:'tabChange'
      },
    });
    dispatch({
      type: 'SET_TAB_SELECTION',
      payload: val,
    });
    if (!PER_TABS.includes(val)) {
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          value: 'Absolute',
        },
      });
    }
  };

  return (
    <div className='tabs-main'>
      <Box className='tabs-main__menuContainer'>
        <Tabs
          value={state.selectedTab}
          onChange={handleChange}
          variant='scrollable'
          scrollButtons='auto'
          selectionFollowsFocus
          TabIndicatorProps={{
            style: {
              backgroundColor: '#fff',
            }
          }}
        >
          {TABS.map((tabItem: any, i: number) => (
              <Tab
                className='tabs-main__menuContainer__menuItem'
                value={tabItem.name}
                sx={{minWidth: 'fit-content', flex: 1}}
                label={tabItem.title}
                style={{
                  backgroundColor: state?.selectedTab === tabItem.name ? '#f7b047' : '',
                  borderRadius: state?.selectedTab === tabItem.name ? '4px' : '',
                  fontWeight: state?.selectedTab === tabItem.name ? 'bold' : 'normal',
                  color: '#fff',
                }}
                {...a11yProps(i)}
              />
            )
          )}
        </Tabs>
      </Box>
      {state?.selectedTab === 'Home sales' && <PredictionHomeSales key='home_sales'/>}
      {state?.selectedTab === 'Days on market' && <PredctionDaysOnMarket key='days_on_market'/>}
      {state?.selectedTab === 'Price' && <PredictionPrice key='price'/>}
      {state?.selectedTab === 'MSP' && <PredictionMsp key='msp'/>}
      {state?.selectedTab === 'Property Type' && <PropertyType type={'zipcode'}/>}
      {state?.selectedTab === 'Rentals' && <PredictionRental key='Rental Index'/>}
    </div>
  );
};

export default React.memo(PredictionTab);
